// Stored files come back as relative paths ("/api/files/..."), but the API can live
// on a different host than the app (api.helcoo.uk vs helcoo.uk) — make them absolute.
const API_BASE = () => (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
// Public logos are served through the CDN (CloudFront) when configured; else the API.
const CDN_BASE = () =>
  (process.env.REACT_APP_CDN_URL || process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const absolute = (base, url) => {
  if (!url) return url;
  if (/^(https?:|data:|blob:)/.test(url)) return url;
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
};

// Public assets (logos) — edge-cached via CDN for speed + low egress.
export const fileUrl = (url) => absolute(CDN_BASE(), url);

// Private files (certificates, receipts, payroll, employee docs, invoices) are tenant-scoped.
// Always go straight to the API (auth enforced, never edge-cached). Plain <a>/<img> can't send
// the Authorization header, so append ?auth=<token>.
export const fileUrlAuth = (url) => {
  const u = absolute(API_BASE(), url);
  if (!u) return u;
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : "";
  if (!token) return u;
  return u.includes("?") ? `${u}&auth=${token}` : `${u}?auth=${token}`;
};
